import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { timestampDate as baseTimestampDate, timestampFromDate, timestampMs } from "@bufbuild/protobuf/wkt";

export { timestampFromDate, timestampMs };

/**
 * Convert a Timestamp to a Date, returning undefined if the timestamp is undefined.
 */
export function timestampDate(timestamp: Timestamp): Date;
export function timestampDate(timestamp: Timestamp | undefined): Date | undefined;
export function timestampDate(timestamp: Timestamp | undefined): Date | undefined {
    if (!timestamp) return undefined;
    return baseTimestampDate(timestamp);
}
